import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import React, { useState } from 'react'
import { AdvisorEntity } from 'types/AdvisorEntity'

export function AdvisorSelect({
    advisors,
    onCreate,
    onSelect,
    label,
}: {
    advisors: AdvisorEntity[]
    onCreate?: (advisor: { name: string }) => void
    onSelect: (advisor: AdvisorEntity) => void
    label: string
}) {
    const [inputValue, setInputValue] = useState('')
    const [newAdvisor, setNewAdvisor] = useState<{ name: string } | null>(null)
    const reset = () => {
        setInputValue('')
        setNewAdvisor(null)
    }
    const handleSelect = (advisor: AdvisorEntity) => {
        onSelect(advisor)
        reset()
    }
    return (
        <Autocomplete
            autoHighlight
            freeSolo
            fullWidth
            options={advisors}
            getOptionLabel={(option) => (option === null ? '' : typeof option === 'string' ? option : option.name)}
            inputValue={inputValue}
            value={newAdvisor}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue)
            }}
            renderInput={(params) => <TextField {...params} label={label} />}
            onChange={(event, newValue, reason) => {
                if (reason === 'selectOption') {
                    setNewAdvisor(newValue)
                    handleSelect(newValue)
                    return newValue
                }
                if (reason == 'createOption' && typeof newValue === 'string' && onCreate) {
                    const cleanedAdvisorName = newValue.trim()
                    setNewAdvisor({ name: cleanedAdvisorName })
                    onCreate({ name: cleanedAdvisorName })
                    reset()
                    return cleanedAdvisorName
                }
            }}
        />
    )
}
